import { useLayoutEffect } from "react";
/** Guest chat owns its scroll containers; the invitation page does not. */
export function useGuestViewport() {
    useLayoutEffect(() => {
        const media = window.matchMedia("(max-width: 991px)");
        let release;
        const sync = () => {
            release?.();
            release = undefined;
            if (!media.matches)
                return;
            const html = document.documentElement;
            const body = document.body;
            const previousRestoration = window.history.scrollRestoration;
            const hadHtmlClass = html.classList.contains("guest-chat-viewport");
            const hadBodyClass = body.classList.contains("guest-chat-viewport");
            html.classList.add("guest-chat-viewport");
            body.classList.add("guest-chat-viewport");
            window.history.scrollRestoration = "manual";
            const reset = () => {
                // Explicit instant scrolling bypasses the site's smooth-scroll rule.
                window.scrollTo({ top: 0, left: 0, behavior: "instant" });
                html.scrollTop = 0;
                body.scrollTop = 0;
            };
            reset();
            const frame = window.requestAnimationFrame(reset);
            window.addEventListener("pageshow", reset);
            release = () => {
                window.cancelAnimationFrame(frame);
                window.removeEventListener("pageshow", reset);
                if (!hadHtmlClass)
                    html.classList.remove("guest-chat-viewport");
                if (!hadBodyClass)
                    body.classList.remove("guest-chat-viewport");
                window.history.scrollRestoration = previousRestoration;
            };
        };
        sync();
        media.addEventListener("change", sync);
        return () => {
            media.removeEventListener("change", sync);
            release?.();
        };
    }, []);
}
